export default `
    # if (data.cf) {#
        <div id="#= data.id#_cid" class="#= data.textareaBsc #">
            <fieldset id="#= data.id#_well" class="textarea-cf-fieldset">
                <legend id="#= data.id#_legend" class="textarea-cf-legend bind-label"
                    # if (data.label) { # data-bind="#= data.label #" # } #
                    data-label-for-id="#= data.id #"
                        >#=data.hcLabel || data.hcLabelAbove ||""## if (!data.hideSS) { #<span class="textarea-cf" title="This is a custom field">C</span># } #</legend>
                <div class="pane-field">
                    <textarea id="#: data.id #" class="textarea-cf-height bind-value #: data.classes || "" # # if (data.disabled) { # disabled # } #"
                        # if (data.disabled) { # disabled # } #
                        # if (data.required) { # required # } #
                        # if (data.readonly) { # readonly # } #
                        # if (data.bindValue) { # data-bind="#= data.bindValue #" # } #
                        # if (data.placeholder) { # placeholder="#= z.ll(data.placeholder) #" # } #
                        # if (data.maxLength) { # max-length="#= data.maxLength #" # } #
                    >
                    </textarea>
                    # if (data.required) { #
                        <span class="required">
                        </span>
                    # } #
                </div>
            </fieldset>
        </div>
    #} else { #
        <div class="pane-field #= data.containerClasses || "" # #= data.bsc || "" #">
            <textarea id="#: data.id #" class="bind-value #: data.classes || "" # # if (data.disabled) { # disabled # } #"
                # if (data.disabled) { # disabled # } #
                # if (data.required) { # required # } #
                # if (data.readonly) { # readonly # } #
                # if (data.bindValue) { # data-bind="#= data.bindValue #" # } #
                # if (data.placeholder) { # placeholder="#= z.ll(data.placeholder) #" # } #
                # if (data.maxLength) { # max-length="#= data.maxLength #" # } #
            >
            </textarea>
            # if (data.required) { #
                <span class="required">
                </span>
            # } #
        </div>
    #}#
`;
